/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useContext, useState } from "react";
import { CloseOutlined } from "@ant-design/icons";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { Dialog, IconButton } from "@mui/material";
import { DocumentEditContext } from "cms/documents/document-selector/context/document-edit-context";
import { GalleryContext } from "cms/documents/document-selector/gallery/gallery-context";
import { useSnackbar } from "hooks/useSnackbar";
import { DocumentDialogBottomActions } from "cms/documents/document-selector/dialog/actions/document-dialog-bottom-actions";
import { DocumentDialogTopActions } from "cms/documents/document-selector/dialog/actions/document-dialog-top-actions";
import { DocumentDialogGalleryPanel } from "cms/documents/document-selector/dialog/panels/document-dialog-gallery-panel";
import { DocumentDialogUploadPanel } from "cms/documents/document-selector/dialog/panels/document-dialog-upload-panel";
import { DocumentSelectorClientContext } from "cms/documents/document-selector/context/document-selector-client-context";
import { Logger } from "cms/utils/log/logger";

const DocumentSelectDialog = () => {

    const { showSnackbar } = useSnackbar();
    const [documents, setDocuments] = useState();
    const searchFunction = SimpliCityAdminSDK.document.search;
    const scrollableHeight = "480px";

    const {
        openChange,
        handleChangeClose,
        selectedDocument,
        setSelectedDocument,
        MODES,
        mode,
        setMode,
    } = useContext(DocumentEditContext);
    
    const handleCancel = (event) => {
        handleChangeClose(event);
    };

    const galleryCTX = {
        documents,
        setDocuments,
        searchFunction,
        scrollableHeight,
        // onSelectDocument,
        selectedDocument,     // from edit context
        setSelectedDocument,  // from edit context
        showSnackbar,
    };

    const selectTab = (choice) => {
        switch (choice) {
            case MODES.UPLOAD:
                setMode(MODES.UPLOAD);
                break;
            case MODES.SELECT:
                setMode(MODES.SELECT);
                break;
        }
    };
    
    const handleReload = async (document) => {
        Logger.debug("[document] onReload...", document);
        setSelectedDocument(document);
    };
    
    const documentSelectorClientContext = {
        handleReload,
    };

    return (
        <DocumentSelectorClientContext.Provider value={documentSelectorClientContext }>
            <Dialog
                open={openChange}
                onClose={handleChangeClose}
                fullWidth={true}
                maxWidth='lg'
                className="simplicity-document-selector-overlay"
            >
                <GalleryContext.Provider value={galleryCTX}>

                    <div className="base-dialog documentselector">

                        <div className="simplicity-document-selector-window-title">

                            Document Selector

                            <IconButton
                                className="card-icon-button"
                                onClick={handleCancel}
                            >
                                <CloseOutlined/>
                            </IconButton>
                        </div>
                        <DocumentDialogTopActions
                            selectTab={selectTab}
                        />

                        <div className="simplicity-document-selector-window-select">
                          
                            {mode === MODES.UPLOAD && (
                                <DocumentDialogUploadPanel/>
                            )}

                            {mode === MODES.SELECT && (
                                <DocumentDialogGalleryPanel/>
                            )}

                        </div>

                        <DocumentDialogBottomActions/>

                    </div>

                </GalleryContext.Provider>
            </Dialog>
        </DocumentSelectorClientContext.Provider>
    );
};

export { DocumentSelectDialog };
